export function strIsNullOrEmpty(str: string | null | undefined): str is null | undefined | '' {
	return str == null || str === '';
}

function escapeRegExp(string: string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function strReplaceAll(target: string, search: string, replacement: string) {
	const se = escapeRegExp(search);
	return target.replace(new RegExp(se, 'g'), replacement);
}

export function normalize(value?: string) {
	return value?.trim()?.toLowerCase();
}

export function toTitleCase(value: string): string {
	return value.replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}
